/**
 * The tag search of the data-source picker's step 2 (EntityAliasPicker): which of an alias's keys show for a query.
 * Each whitespace-separated word must appear in the key, case ignored; a key in `keep` (bound to a slot) always shows,
 * so what is bound can be seen and cleared whatever is typed. Order is kept; a blank query keeps every key.
 */
export function filterKeys(keys: readonly string[], query: string, keep: ReadonlySet<string>): string[] {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return [...keys];
  return keys.filter((k) => {
    if (keep.has(k)) return true;
    const lower = k.toLowerCase();
    return words.every((w) => lower.includes(w));
  });
}
